import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import woStyles from '../../modules/workorders/Detail/workOrderDetail.module.scss';
import FormattedMessageWithClass from '../../components/formattedMessageWithClass';
import Clickable from '../../components/clickable/Clickable';
import Modal from '../../components/modal';
import closeIcon from '../../icons/close.svg';
import styles from './fields.module.scss';
import Spinner from '../../components/spinner';
import { renderInfoForType } from '../../utils/helpers';

const DataSourceInformation = (props) => {
    const { sourceFields, dataSourceValues, answer, dataSourceID, link } = props;
    const [detailModal, handleDetailModal] = useState(false);

    const selectedField = dataSourceValues?.find(value => (value.description ? `${value.name} - ${value.description}` === answer
        : value.name === answer));

    const columns = sourceFields?.map((field) => {
        const fieldid = field?.id;
        const value = selectedField
            ? selectedField?.[fieldid === 'consumable' ? 'part_type' : fieldid] ?? selectedField?.response?.[fieldid] ?? ''
            : '';
        if (field?.id === 'updated_address' && selectedField?.updated_address) {
            const address = Array.isArray(selectedField?.updated_address) ? selectedField?.updated_address[0]
            : selectedField?.updated_address;
           if (address) {
            const { street, city, state, zip } = address;
            return {
                id: field?.id,
                title: field?.title,
                type: field?.type,
                value: (
                    <span className={woStyles.rowContent}>
                        {street && `${street}, `}
                        {city && `${city}, `}
                        {state && `${state}, `}
                        {zip && `${zip}`}
                    </span>
                )
            };
        }
        }
        if (field?.id === 'tenant_properties__name') {
            let propertyValue = 'NA';

            if (Array.isArray(selectedField?.property) && selectedField?.property?.length > 0) {
                propertyValue = selectedField?.property
                    .map(p => p?.name)
                    .filter(Boolean)
                    .join(', ');
            } else if (selectedField?.tenant_properties__name) {
                propertyValue = selectedField?.tenant_properties__name;
            }
            return {
                id: field?.id,
                title: field?.title,
                type: field?.type,
                value: (
                    <span className={woStyles.rowContent}>
                        {propertyValue}
                    </span>
                )
            };
        }
        return {
            id: field?.id,
            title: field?.title,
            type: field?.type,
            value
        };
    });


    const getDetail = () => (
        <div className={`${woStyles.datasourcecontainer}`}>
            <div className={`${woStyles.requestInfo}`}>
                <div className={woStyles.stepInfo} style={{ width: '100%' }}>
                    {columns?.map(item => (
                        <div className={woStyles.infoHalf} key={item.id}>
                            <FormattedMessageWithClass
                                id={item.id}
                                defaultMessage={item.title}
                                className={woStyles.title}
                            />
                            <span className={woStyles.rowContent}>
                                {(item.type === 'boolean' && (item.value === true ? 'Yes' : 'No'))
                                || (item.id === 'status' && (+item.value === 0 ? 'Active' : 'Inactive'))
                                || (item.id === 'available_quantity' && (item.value ? item.value : '0'))
                                || (item.type === 'date' && renderInfoForType(item, item.value))
                                || (item.type === 'datetime' && renderInfoForType(item, item.value))
                                || item.value}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
    const detailType = React.useMemo(() => {
        if (dataSourceID === 'ds5') {
            return 'tenants';
        }
        return 'parts';
    }, [dataSourceID]);

    return (
        <>
         <div style={{ display: 'flex' }}>
           {link && (
             <Clickable
               className={styles.detailsLink}
               onClick={handleDetailModal}
             >
               <FormattedMessage
                 id="roles.privileges.ViewDetails"
                 defaultMessage="View Details"
                 tagName="p"
               />
             </Clickable>
           )}
         </div>
         {detailModal && (
            <Modal
                width="943px"
                showIn={detailModal}
                onClose={() => handleDetailModal(false)}
            >
                <div>
                    <div className={styles.title}>
                        <FormattedMessage
                                id={
                                    detailType === 'tenants'
                                        ? 'datasource.companyDetail'
                                        : 'datasource.partDetail'
                                }
                                defaultMessage={
                                    detailType === 'tenants'
                                        ? 'Company Details'
                                        : 'Part Detail'
                                }
                                tagName="span"
                            />
                        <Clickable
                         onClick={() => handleDetailModal(false)}
                         className={styles.closeIcon}
                        >
                            <img src={closeIcon} alt="X" />
                        </Clickable>
                    </div>
                    {dataSourceValues === undefined
                    ? <div className={styles.spinnerDiv}>
                        <Spinner active={!dataSourceValues} size={50} />
                      </div>
                    : <div className={`container ${styles.contentDivStyles}`}>
                        {getDetail()}
                      </div>}
                </div>
            </Modal>
         )}
         {!link && getDetail()}
        </>
    );
};

export default DataSourceInformation;
